import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const MediaValueCalculatorConnector = React.lazy(
  () => import('components/Tools/MediaValueCalculator/MediaValueCalculator'),
);

function ScreensToolsMediaValue() {
  return (
    <BaseLayout>
      <DocumentTitle>Media Value Calculator</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <MediaValueCalculatorConnector />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensToolsMediaValue;
